// faq — am. FAQ page chrome. The Q&A bodies themselves live under faq1q..faq8a.

export default {
  faqHeroA: 'ተደጋጋሚ',
  faqHeroB: 'ጥያቄዎች',
  faqSearchPlaceholder: 'ጥያቄዎችን ይፈልጉ...',
  faqCatAll: 'ሁሉም ምድቦች',
  faqCatAccount: 'መለያ',
  faqCatBuying: 'ግዢ',
  faqCatSelling: 'ሽያጭ',
  faqCatPayments: 'ክፍያ',
  faqCatDelivery: 'ማድረስ',
  faqNoMatch: 'ከፍለጎትዎ ጋር የሚሄደው ጥያቄ የለም።',
  faqStillTitle: 'አሁን ግን ጥያቄ ይፈላል?',
  faqStillDesc: 'የድጋፍ ቡድናችን ለሚፈልጉት ማንኛውም ነገር እንዳግዙዎ እዚህና ነው።',
  faqContactSupport: 'ድጋፍ ያግኙ',
  faqCtaTitle: 'የሚፈልጉትን አልገኘዎም?',
  faqCtaDesc: 'ቡድናችን ስለ AllThings ያላታት ማንኛውም ጥያቄ ለመመልስ ተዘጋጅተዋል።',
  faqPhoneLabel: (n) => `ስልክ ${n}`,
  faqSupportHours: 'የድጋፍ ሰዓት',
};